export default function TaskComments({
 task,
 commentInputs,
 setCommentInputs,
 onAddComment,
 onDeleteComment,
 submittingComment,
}) {


return (

<div className="mt-5">


<div className="space-y-3">

{
task.comments?.map(comment=>(

<div
key={comment.id}
className="
bg-[#111318]
border
border-slate-800
rounded-xl
p-3
"
>

<div className="flex justify-between">

<div>

<div className="text-sm text-slate-300 font-medium">
{comment.created_by}
</div>

<div className="
text-slate-400
text-sm
mt-1
whitespace-pre-wrap
">
{comment.comment}
</div>

</div>


<button
onClick={() =>
 onDeleteComment(
  task.id,
  comment.id
 )
}
className="
text-slate-500
hover:text-red-400
"
>
✕
</button>


</div>

</div>

))

}

</div>



<div className="flex gap-2 mt-4">

<input
placeholder="Add comment..."
value={
 commentInputs[task.id] || ""
}
onChange={(e)=>
 setCommentInputs(prev=>({
  ...prev,
  [task.id]:e.target.value
 }))
}
onKeyDown={(e)=>{
 if(e.key==="Enter")
  onAddComment(task.id)
}}
className="
flex-1
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
/>


<button
disabled={submittingComment}
onClick={() =>
 onAddComment(task.id)
}
className="
bg-blue-600
rounded-xl
px-4
"
>
Send
</button>


</div>


</div>

)

}